import { render, staticRenderFns } from "./office_user.vue?vue&type=template&id=0810ec3e&"
import script from "./office_user.vue?vue&type=script&lang=js&"
export * from "./office_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports